import { Cloud } from '@silbo/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import toast from '../../../../toast';

type RejectRequestParams = { id: string; reason?: string };

export const useRejectRequestMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: unknown, variables: RejectRequestParams) => void;
  onError?: (error: unknown, variables: RejectRequestParams) => void;
} = {}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('bed-management');

  const mutation = useMutation({
    mutationFn: async ({ id, reason }: RejectRequestParams) => {
      return await Cloud.rejectPerformerRequest({ id, reason });
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['requests'] });
      toast.success(t('requestDetails.actions.reject.successToast'));
      onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Failed to reject accommodation request:', error);
      toast.error(t('requestDetails.actions.reject.errorToast'));
      onError?.(error, variables);
    },
  });

  return {
    rejectRequest: mutation.mutateAsync,
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
